// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","link":"_2SvcH0Pv1xG4xE4qzCq7cp","plain":"_2NEPHNGcWJkCpKcB_yFq7Y","inherit":"_31_OU8REZhCsYDnilPTjnP"};